var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Box, Text, Center, Flex, Popover, PopoverTrigger, PopoverContent, Button, PopoverCloseButton, PopoverBody, Icon, Tag, Select, CircularProgress, CircularProgressLabel, } from '@chakra-ui/react';
import React from 'react';
import { Observer, observer } from 'mobx-react';
import { StoreContext } from '@/app/uistore/Rootstore';
import { FiLogOut } from '@react-icons/all-files/fi/FiLogOut';
import { Image } from "@chakra-ui/react";
import { AppState } from '@/share/AppState';
import { AppColor, FontSize } from '../const/AppDefaults';
import { MdDelete } from '@react-icons/all-files/md/MdDelete';
import { MdVpnKey } from '@react-icons/all-files/md/MdVpnKey';
import { MdPermContactCalendar } from '@react-icons/all-files/md/MdPermContactCalendar';
import { MdDevices } from '@react-icons/all-files/md/MdDevices';
import { MdMail } from '@react-icons/all-files/md/MdMail';
import { MdWarning } from '@react-icons/all-files/md/MdWarning';
import { formatBytes, isIpadScreen, testIsMobile } from "@@/Util";
import { MasterPasswordDialogState, MasterPasswordDialog } from '../UIComponents/MasterPasswordDialog';
import { RegisterNewDeviceDialog, RegisterNewDeviceStore } from '../UIComponents/RegisterNewDevice';
import hicon from "@/assets/wicon_header.png";
import { GoPrimitiveDot } from '@react-icons/all-files/go/GoPrimitiveDot';
import { ProfileDialog, ProfileDialogState } from '../UIComponents/ProfileDialog';
import { FaUsers } from '@react-icons/all-files/fa/FaUsers';
import { MdDevicesOther } from '@react-icons/all-files/md/MdDevicesOther';
import { FiSettings } from '@react-icons/all-files/fi/FiSettings';
import { RiShieldUserFill } from '@react-icons/all-files/ri/RiShieldUserFill';
import { FaUserCircle } from '@react-icons/all-files/fa/FaUserCircle';
import { FaSearch } from '@react-icons/all-files/fa/FaSearch';
import { FaLayerGroup } from '@react-icons/all-files/fa/FaLayerGroup';
import { ROOTFolder } from '../const/AppDefaults';
import { FcVideoCall } from '@react-icons/all-files/fc/FcVideoCall';
import { MdDataUsage } from '@react-icons/all-files/md/MdDataUsage';
import { FaUserSecret } from '@react-icons/all-files/fa/FaUserSecret';
import { MdNotifications } from '@react-icons/all-files/md/MdNotifications';
import { MdClose } from '@react-icons/all-files/md/MdClose';
import { GiPartyPopper } from '@react-icons/all-files/gi/GiPartyPopper';
import { BeatLoader } from 'react-spinners';
import { Virtuoso } from 'react-virtuoso';
import { DateLib } from '@@/Datelib';
import { MdAssignment } from '@react-icons/all-files/md/MdAssignment';
import { FcDataSheet } from '@react-icons/all-files/fc/FcDataSheet';
import { FcDocument } from '@react-icons/all-files/fc/FcDocument';
import { FaFileUpload } from '@react-icons/all-files/fa/FaFileUpload';
import { FaFileDownload } from '@react-icons/all-files/fa/FaFileDownload';
import { FaDownload } from '@react-icons/all-files/fa/FaDownload';
import { BiError } from '@react-icons/all-files/bi/BiError';
import { FaFile } from '@react-icons/all-files/fa/FaFile';
import { ImDownload } from '@react-icons/all-files/im/ImDownload';
let AppHeader = class AppHeader extends React.Component {
    constructor() {
        super(...arguments);
        this.masterPasswordDialog = new MasterPasswordDialogState();
        this.registerNewDevice = new RegisterNewDeviceStore();
        this.profileDialogState = new ProfileDialogState();
        this.tiles = [
            { title: 'Letrs', key: 'letrs', image: React.createElement(Icon, { h: '16px', w: '16px', as: FaLayerGroup }), background: '#685894' },
            { title: 'Devices', key: 'devices', image: React.createElement(Icon, { h: '16px', w: '16px', as: MdDevices }), background: '#685894' },
            { title: 'Contacts', key: 'contacts', image: React.createElement(Icon, { h: '16px', w: '16px', as: MdPermContactCalendar }), background: '#685894' },
            { title: 'Search', key: 'search', image: React.createElement(Icon, { h: '16px', w: '16px', as: FaSearch }), background: '#685894' },
            // { title: 'Calls', key: 'calllogs', image: <Icon h={'20px'} w={'20px'} as={MdCall} />, background: '#685894' },
            /*   { title: 'Managed Contacts', key: 'managedletrs', image: <Icon h={'20px'} w={'20px'} as={MdPublic} />, background: '#685894' },
               { title: 'Projects', key: 'workspaces', image: <Icon h={'20px'} w={'20px'} as={FaBox} />, background: '#685894' },
               { title: 'Tasks', key: 'tasks', image: <Icon h={'20px'} w={'20px'} as={FaProjectDiagram} />, background: '#685894' },
       */
        ];
        this.mobiletiles = [
            { title: 'Letrs', key: 'letrs', image: React.createElement(Icon, { h: '16px', w: '16px', as: FaLayerGroup }), background: '#685894' },
            { title: 'Devices', key: 'devices', image: React.createElement(Icon, { h: '16px', w: '16px', as: MdDevices }), background: '#685894' },
            { title: 'Contacts', key: 'contacts', image: React.createElement(Icon, { h: '16px', w: '16px', as: MdPermContactCalendar }), background: '#685894' }
        ];
        this.admintiles = [
            { title: 'Contacts', key: 'users', image: React.createElement(Icon, { h: '16px', w: '16px', as: FaUsers }) },
            { title: 'Devices', key: 'devices', image: React.createElement(Icon, { h: '16px', w: '16px', as: MdDevicesOther }) },
            { title: 'Letrs', key: 'letrs', image: React.createElement(Icon, { h: '16px', w: '16px', as: MdMail }) },
            // { title: 'Tasks', key: 'tasks', image: <Icon h={'16px'} w={'16px'} as={MdAssignment} /> },
            { title: 'Settings', key: 'settings', image: React.createElement(Icon, { h: '16px', w: '16px', as: FiSettings }) }
        ];
    }
    imageClicked() {
        const rstore = this.context;
        if (rstore.authStore.appstate === AppState.Login) {
            rstore.confirmStore.setMessage("Are you sure you want to reset organisation?");
            rstore.confirmStore.setOpen(true);
            rstore.confirmStore.setOkCB(() => {
                rstore.authStore.wipe();
            });
        }
        else {
            if (rstore.homeViewStore.activeTab !== 'letrs') {
                rstore.letrAndTagStore.reset();
                rstore.messageStore.reset();
                rstore.managedLetrsStore.reset();
                rstore.homeViewStore.setActiveTile({ title: 'Letrs', key: 'letrs' });
                rstore.homeViewStore.setActiveTab('letrs');
            }
        }
    }
    async wipe() {
        const rstore = this.context;
        rstore.confirmStore.setMessage("Are you sure you want to wipe the device?");
        rstore.confirmStore.setOkCB(() => {
            rstore.workingStore.setMessage("Deleting the device");
            rstore.workingStore.setOpen(true);
            rstore.authStore.wipe();
        });
        rstore.confirmStore.setOpen(true);
    }
    showAdmin() {
        const rstore = this.context;
        rstore.appheaderStore.upgradeSession();
        rstore.appheaderStore.setAdminView(true);
        // window.open("https://admin.letrwing.com", "letrwing-admin");
    }
    showUser() {
        const rstore = this.context;
        rstore.appheaderStore.setAdminView(false);
        // window.open("https://admin.letrwing.com", "letrwing-admin");
    }
    showMasterPasswordDialog() {
        this.masterPasswordDialog.setOpen(true);
    }
    showRegisterNewDevice() {
        this.registerNewDevice.setOpen(true);
    }
    unreadDot() {
        return React.createElement(Icon, { ml: '3px', mt: -2, w: '35px', color: 'red', as: GoPrimitiveDot });
    }
    showProfileDialog() {
        const rstore = this.context;
        rstore.userStore.getUserProfile();
        this.profileDialogState.setOpen(true);
    }
    buildTile() {
        const rstore = this.context;
        let ret = [];
        const activeTab = rstore.homeViewStore.activeTab;
        this.tiles.map(tile => {
            ret.push(React.createElement(Flex, { flexDirection: 'row', key: tile.key, _hover: {
                    cursor: rstore.homeViewStore.activeTab !== 'letrs' ||
                        rstore.authStore.appstate === AppState.Login ?
                        'pointer' : ''
                }, className: tile.key === activeTab ? 'header-tab-item active' : 'header-tab-item', alignItems: 'center', mr: '20px', color: AppColor.HeaderIconColor, mt: '10px', onClick: () => {
                    if (rstore.letrAndTagStore.activeview !== 'project' &&
                        rstore.projectStore.activefolderid === "") {
                        rstore.projectStore.setActiveFolderId(ROOTFolder);
                    }
                    if (tile.key === 'letrs' && rstore.homeViewStore.activeTab === 'letrs') {
                        rstore.letrAndTagStore.setShowProjectsMenu(true);
                        return;
                    }
                    rstore.letrAndTagStore.reset();
                    rstore.documentDetailStore.reset();
                    rstore.repliesStore.reset();
                    rstore.draftDetailStore.setShowDraftingView(false);
                    rstore.letrAndTagStore.setActiveView("project");
                    rstore.letrAndTagStore.setActiveViewer("project");
                    rstore.repliesStore.reset();
                    rstore.projectStore.loadAllFolders();
                    rstore.homeViewStore.setActiveTab(tile.key);
                } },
                tile.image,
                !isIpadScreen() && React.createElement(Box, { ml: 2 },
                    React.createElement(Text, { fontSize: 16, color: AppColor.HeaderIconColor }, tile.title))));
        });
        return ret;
    }
    buildMobileTile() {
        const rstore = this.context;
        let ret = [];
        const activeTab = rstore.homeViewStore.activeTab;
        ret.push(React.createElement(Select, { size: 'sm', width: '100px', borderColor: AppColor.FilterHeaderFontColor, onChange: (e) => {
                e.stopPropagation();
                const tile = e.currentTarget.value;
                if (rstore.letrAndTagStore.activeview !== 'project' &&
                    rstore.projectStore.activefolderid === "") {
                    rstore.projectStore.setActiveFolderId(ROOTFolder);
                }
                if (tile.toLowerCase() === 'letrs' && rstore.homeViewStore.activeTab === 'letrs') {
                    rstore.letrAndTagStore.setShowProjectsMenu(true);
                    return;
                }
                rstore.letrAndTagStore.reset();
                rstore.documentDetailStore.reset();
                rstore.repliesStore.reset();
                rstore.draftDetailStore.setShowDraftingView(false);
                rstore.letrAndTagStore.setActiveView("project");
                rstore.letrAndTagStore.setActiveViewer("project");
                rstore.repliesStore.reset();
                rstore.projectStore.loadAllFolders();
                rstore.homeViewStore.setActiveTab(tile);
            }, value: rstore.homeViewStore.activeTab }, this.mobiletiles.map((op) => React.createElement("option", { value: op.key, key: op.key }, op.title))));
        return ret;
    }
    buildAdminTile() {
        const rstore = this.context;
        let ret = [];
        const activeTab = rstore.adminViewStore.activeTab;
        this.admintiles.map(tile => {
            ret.push(React.createElement(Flex, { flexDirection: 'row', key: tile.key, _hover: { cursor: 'pointer' }, justifyContent: 'center', className: tile.key === activeTab ? 'header-tab-item active' : 'header-tab-item', alignItems: 'center', mr: '20px', color: AppColor.HeaderIconColor, mt: '10px', onClick: () => {
                    rstore.adminViewStore.setActiveTab(tile.key);
                } },
                tile.image,
                React.createElement(Box, { ml: 2 },
                    React.createElement(Text, { fontSize: 16, color: AppColor.HeaderIconColor }, tile.title))));
        });
        return ret;
    }
    showRecoveryCode() {
        const rstore = this.context;
        rstore.recoveryCodeDialog.setShowPassword(true);
        rstore.recoveryCodeDialog.bdialogstate.setOpen(true);
    }
    showMeeting() {
        const rstore = this.context;
        rstore.mediastore.setShowHiddenBox(false);
        rstore.mediastore.setOpen(true);
    }
    render() {
        var _a, _b;
        const rstore = this.context;
        const cursorshape = (rstore.authStore.appstate === AppState.Login || rstore.authStore.appstate === AppState.LoggedIn) ? 'pointer' : '';
        const selectedLetrSubject = (_b = (_a = rstore.letrAndTagStore.letrsById.get(rstore.letrAndTagStore.selectedLetr)) === null || _a === void 0 ? void 0 : _a.subject) !== null && _b !== void 0 ? _b : "";
        return (React.createElement(React.Fragment, null,
            React.createElement(RegisterNewDeviceDialog, { state: this.registerNewDevice }),
            React.createElement(Flex, { width: '100%', height: '70px', borderBottomWidth: '1px', background: AppColor.AnnotationDialogHeader, borderBottomColor: '#e4e4e4' },
                React.createElement(Center, { _hover: { cursor: cursorshape }, height: '70px', className: testIsMobile() ? 'mobile-logo-container' : 'logo-container', onClick: () => this.imageClicked() },
                    React.createElement(Image, { src: hicon })),
                rstore.authStore.appstate === AppState.LoggedIn &&
                    React.createElement(Flex, { width: '60%', height: 70, alignItems: 'center', flexDirection: 'row', ml: '10px' },
                        !testIsMobile() && !rstore.appheaderStore.adminview && this.buildTile(),
                        testIsMobile() && !rstore.appheaderStore.adminview && this.buildMobileTile(),
                        rstore.appheaderStore.adminview && this.buildAdminTile(),
                        rstore.authStore.appstate === AppState.LoggedIn && rstore.appheaderStore.showverify
                            && !rstore.appheaderStore.adminview &&
                            React.createElement(Box, null,
                                React.createElement(Flex, { style: {
                                        flexDirection: 'row', backgroundColor: '#fcece9', borderRadius: 10, padding: 5,
                                        minHeight: 50, alignItems: 'center', borderColor: '#f6eae8', borderWidth: 1, alignSelf: 'center'
                                    }, _hover: { cursor: 'pointer' }, onClick: () => this.showAdmin() },
                                    React.createElement(Icon, { as: MdWarning, height: '30px', width: '30px', color: 'red' }),
                                    React.createElement(Box, null,
                                        React.createElement(Text, { style: { color: 'red', fontSize: 14 } }, "Verification Needed!"))))),
                rstore.authStore.appstate === AppState.LoggedIn &&
                    React.createElement(Flex, { width: '35%', height: 70, alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end' },
                        React.createElement(Flex, { pos: 'relative', height: 70, alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end', mr: testIsMobile() ? '5px' : '20px' },
                            React.createElement(Flex, { color: AppColor.HeaderIconColor, alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end', _hover: { cursor: 'pointer' }, onClick: () => {
                                    if (rstore.homeViewStore.shownewfileview) {
                                        rstore.homeViewStore.setShowFiles(false);
                                    }
                                    else {
                                        if (rstore.homeViewStore.newfiles.size === 0) {
                                            rstore.homeViewStore.getFiles();
                                        }
                                        if (rstore.homeViewStore.newfilecount > 0) {
                                            rstore.homeViewStore.getFiles(true);
                                        }
                                        rstore.homeViewStore.setShowFiles(true);
                                    }
                                } },
                                React.createElement(Icon, { w: '25px', h: '25px', as: FaFileUpload }),
                                rstore.homeViewStore.newfilecount > 0 && React.createElement(Text, { pos: 'absolute', top: '12px', right: '-12px', fontSize: '12px' }, rstore.homeViewStore.newfilecount > 9 ? '9+' : rstore.homeViewStore.newfilecount)),
                            React.createElement(Box, { pos: 'absolute', top: '70px', right: testIsMobile() ? "-50px" : "-8px" },
                                React.createElement(NewFilesView, null))),
                        rstore.appheaderStore.adminview && React.createElement(Flex, { pos: 'relative', height: 70, alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end', mr: testIsMobile() ? '5px' : '20px' },
                            React.createElement(Flex, { color: AppColor.HeaderIconColor, alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end', _hover: { cursor: 'pointer' }, className: rstore.appheaderStore.queuedItems.length > 0 ? 'blob' : '', onClick: () => {
                                    if (rstore.appheaderStore.showadmindownloadqueue) {
                                        rstore.appheaderStore.setShowAdminDownloadQueueItemView(false);
                                    }
                                    else {
                                        rstore.appheaderStore.setShowAdminDownloadQueueItemView(true);
                                    }
                                } },
                                React.createElement(Icon, { w: '22px', h: '22px', as: ImDownload })),
                            React.createElement(Box, { pos: 'absolute', top: '70px', right: testIsMobile() ? "-40px" : "-8px" },
                                React.createElement(AdminDownloadQueueView, null))),
                        !rstore.appheaderStore.adminview && React.createElement(Flex, { pos: 'relative', height: 70, alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end', mr: testIsMobile() ? '5px' : '20px' },
                            React.createElement(Flex, { color: AppColor.HeaderIconColor, alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end', _hover: { cursor: 'pointer' }, className: rstore.appheaderStore.queuedItems.length > 0 ? 'blob' : '', onClick: () => {
                                    if (rstore.appheaderStore.showdownloadqueue) {
                                        rstore.appheaderStore.setShowDownloadQueueItemView(false);
                                    }
                                    else {
                                        rstore.appheaderStore.setShowDownloadQueueItemView(true);
                                    }
                                } },
                                React.createElement(Icon, { w: '22px', h: '22px', as: FaDownload })),
                            React.createElement(Box, { pos: 'absolute', top: '70px', right: testIsMobile() ? "-40px" : "-8px" },
                                React.createElement(DownloadQueueView, null))),
                        React.createElement(Flex, { pos: 'relative', height: 70, alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end', mr: testIsMobile() ? '5px' : '20px' },
                            React.createElement(Flex, { color: AppColor.HeaderIconColor, alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end', _hover: { cursor: 'pointer' }, onClick: () => {
                                    if (rstore.homeViewStore.showtasks) {
                                        rstore.homeViewStore.setShowTaskView(false);
                                    }
                                    else {
                                        if (rstore.homeViewStore.tasks.size === 0) {
                                            rstore.homeViewStore.getAssignedTasks();
                                        }
                                        if (rstore.homeViewStore.newtaskcount > 0) {
                                            rstore.homeViewStore.getAssignedTasks(true);
                                        }
                                        rstore.homeViewStore.setShowTaskView(true);
                                    }
                                } },
                                React.createElement(Icon, { w: '25px', h: '25px', as: MdAssignment }),
                                rstore.homeViewStore.newtaskcount > 0 && React.createElement(Text, { pos: 'absolute', top: '12px', right: '-12px', fontSize: '12px' }, rstore.homeViewStore.newtaskcount > 9 ? '9+' : rstore.homeViewStore.newtaskcount)),
                            React.createElement(Box, { pos: 'absolute', top: '70px', right: testIsMobile() ? "-40px" : "-8px" },
                                React.createElement(AssignedTasksView, null))),
                        React.createElement(Flex, { marginRight: testIsMobile() ? '10px' : '35px', pos: 'relative', height: 70, alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end' },
                            React.createElement(Flex, { color: AppColor.HeaderIconColor, alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end', _hover: { cursor: 'pointer' }, onClick: () => {
                                    if (rstore.homeViewStore.shownotifyview) {
                                        rstore.homeViewStore.setShowNotifyView(false);
                                    }
                                    else {
                                        if (rstore.homeViewStore.logs.size === 0) {
                                            rstore.homeViewStore.getRecentLogs();
                                        }
                                        if (rstore.homeViewStore.newnotifycount > 0) {
                                            rstore.homeViewStore.getRecentLogs(true);
                                        }
                                        rstore.homeViewStore.setShowNotifyView(true);
                                    }
                                } },
                                React.createElement(Icon, { w: '25px', h: '25px', as: MdNotifications }),
                                rstore.homeViewStore.newnotifycount > 0 && React.createElement(Text, { pos: 'absolute', top: '12px', right: '-12px', fontSize: '12px' }, rstore.homeViewStore.newnotifycount > 9 ? '9+' : rstore.homeViewStore.newnotifycount)),
                            React.createElement(Box, { pos: 'absolute', top: '70px', right: testIsMobile() ? "-30px" : "-8px" },
                                React.createElement(NotificationView, null))),
                        !testIsMobile() && rstore.authStore.isAdmin && rstore.appheaderStore.usedspace > 0 && React.createElement(Flex, { pos: 'relative', mr: '20px', align: 'center', flexDir: 'column' },
                            React.createElement(Icon, { w: '25px', h: '25px', color: AppColor.TopBarIconColor, as: MdDataUsage, _hover: { cursor: 'pointer' }, onClick: () => {
                                    rstore.appheaderStore.setshowspacemenu(!rstore.appheaderStore.showspacemenu);
                                } }),
                            rstore.appheaderStore.pendingbill && React.createElement(Tag, { size: 'sm' }, "Payment Due"),
                            rstore.appheaderStore.showspacemenu && React.createElement(Box, { borderWidth: '1px', borderColor: 'lightgray', zIndex: 20, pos: 'absolute', top: '10', bg: 'white', right: '0px', width: '200px' },
                                React.createElement(Flex, { align: 'center', margin: '5px', borderBottomWidth: '1px', height: '70px', width: '90%' },
                                    React.createElement(Text, { w: '60%' }, "Used Filespace"),
                                    React.createElement(Text, { fontWeight: 'bold', fontSize: '14px', ml: "3px" }, formatBytes(rstore.appheaderStore.usedspace))),
                                React.createElement(Flex, { align: 'center', margin: '5px', borderBottomWidth: '1px', height: '70px', width: '90%' },
                                    React.createElement(Text, { w: '60%' }, "Total Users"),
                                    React.createElement(Text, { fontWeight: 'bold', fontSize: '14px', ml: "3px" }, rstore.appheaderStore.useduser)),
                                React.createElement(Flex, { align: 'center', margin: '5px', borderBottomWidth: '1px', height: '70px', width: '90%' },
                                    React.createElement(Text, { w: '60%' }, "Used Metaspace"),
                                    React.createElement(Text, { fontWeight: 'bold', fontSize: '14px', ml: "3px" }, formatBytes(rstore.appheaderStore.usedmspace))))),
                        rstore.mediastore.activecall && React.createElement(Icon, { _hover: { cursor: 'pointer' }, onClick: () => this.showMeeting(), as: FcVideoCall, title: 'Open Ongoing Meeting', mr: '30px', width: '40px', height: '40px' }),
                        React.createElement(Box, { marginRight: '5px', className: 'popover-account' },
                            React.createElement(Popover, { onClose: () => rstore.appheaderStore.setMenuState(false), onOpen: () => rstore.appheaderStore.setMenuState(true), isOpen: rstore.appheaderStore.menuopen },
                                React.createElement(PopoverTrigger, null,
                                    React.createElement(Button, { size: 'md', height: '40px', width: '40px', border: '2px', borderRadius: '50%', borderColor: AppColor.HeaderIconColor, onClick: () => rstore.appheaderStore.toggleMenu(), _focus: { boxShadow: 'none' } }, rstore.authStore.username ? rstore.authStore.username.substring(0, 1) : '')),
                                React.createElement(PopoverContent, { display: rstore.appheaderStore.menuopen ? '' : 'none', borderColor: '#829eb9', _focus: { boxShadow: 'none', outline: 'grey' }, backgroundColor: '#FFFFFF' },
                                    React.createElement(PopoverCloseButton, { onClick: () => rstore.appheaderStore.setMenuState(false) }),
                                    React.createElement(PopoverBody, { zIndex: 20, color: '#000', padding: 0, marginTop: '10%' },
                                        React.createElement(Text, { fontSize: '16px', paddingLeft: '15px', fontWeight: 'bold' }, rstore.authStore.username),
                                        React.createElement(Box, { style: { padding: 10, paddingLeft: 15 }, className: 'option-panel' },
                                            React.createElement(Button, { _focus: { boxShadow: 'none', outline: 'none' }, leftIcon: React.createElement(FiLogOut, null), onClick: () => this.logoutUser(), variant: 'unstyled' }, "Logout")),
                                        React.createElement(Box, { style: { padding: 5, paddingLeft: 15 }, className: 'option-panel' },
                                            React.createElement(Button, { _focus: { boxShadow: 'none', outline: 'none' }, leftIcon: React.createElement(MdDelete, null), onClick: () => this.wipe(), variant: 'unstyled' }, "Delete Device")),
                                        React.createElement(Box, { style: { padding: 5, paddingLeft: 15 }, className: 'option-panel' },
                                            React.createElement(ProfileDialog, { state: this.profileDialogState }),
                                            React.createElement(Button, { _focus: { boxShadow: 'none', outline: 'none' }, leftIcon: React.createElement(MdVpnKey, null), onClick: () => this.showProfileDialog(), variant: 'unstyled' }, "Profile")),
                                        React.createElement(Box, { style: { padding: 5, paddingLeft: 15 }, className: 'option-panel' },
                                            React.createElement(Button, { _focus: { boxShadow: 'none', outline: 'none' }, leftIcon: React.createElement(FaUserSecret, null), onClick: () => this.showRecoveryCode(), variant: 'unstyled' }, "Recovery Code")),
                                        !testIsMobile() && rstore.authStore.isAdmin && !rstore.appheaderStore.adminview && React.createElement(Box, { style: { padding: 5, paddingLeft: 15 }, className: 'option-panel' },
                                            React.createElement(Button, { _focus: { boxShadow: 'none', outline: 'none' }, leftIcon: React.createElement(RiShieldUserFill, null), onClick: () => this.showAdmin(), variant: 'unstyled' }, "Admin View")),
                                        rstore.authStore.isAdmin && rstore.appheaderStore.adminview && React.createElement(Box, { style: { padding: 5, paddingLeft: 15 }, className: 'option-panel' },
                                            React.createElement(Button, { _focus: { boxShadow: 'none', outline: 'none' }, leftIcon: React.createElement(FaUserCircle, null), onClick: () => this.showUser(), variant: 'unstyled' }, "User View")),
                                        rstore.authStore.isAdmin && React.createElement(Box, { style: { padding: 5, paddingLeft: 15 }, className: 'option-panel' },
                                            this.masterPasswordDialog.open && React.createElement(MasterPasswordDialog, { state: this.masterPasswordDialog }),
                                            React.createElement(Button, { _focus: { boxShadow: 'none', outline: 'none' }, leftIcon: React.createElement(MdVpnKey, null), onClick: () => this.showMasterPasswordDialog(), variant: 'unstyled' }, "Master Password"))))))))));
    }
    logoutUser() {
        const rstore = this.context;
        rstore.authStore.logout();
    }
};
AppHeader.contextType = StoreContext;
AppHeader = __decorate([
    observer
], AppHeader);
export { AppHeader };
let AdminDownloadQueueView = class AdminDownloadQueueView extends React.Component {
    buildItem(item) {
        var _a, _b;
        const rstore = this.context;
        return React.createElement(Box, { margin: '10px', borderBottomColor: 'lightgray', borderBottomWidth: '1px', minH: '100px', mt: '5px' },
            React.createElement(Flex, { align: 'center' },
                React.createElement(Flex, { w: '80%', align: 'center' },
                    React.createElement(Icon, { w: '16px', h: '16px', color: AppColor.TopBarIconColor, as: FaFileDownload, ml: '1px' }),
                    React.createElement(Text, { className: 'task-header' }, item.title)),
                React.createElement(Observer, null, () => React.createElement(Flex, { align: 'center' },
                    item.downloading && !item.inqueue &&
                        React.createElement(CircularProgress, { value: item.downloadProgress, color: AppColor.Default },
                            React.createElement(CircularProgressLabel, null, item.downloadProgress + "%")),
                    item.inqueue &&
                        React.createElement(Text, { fontSize: FontSize.SmallIconLabel, fontWeight: 'bold' }, 'Queued'),
                    item.downloaderror &&
                        React.createElement(Flex, { align: 'center', justify: 'center', flexDir: 'column', ml: testIsMobile() ? '5px' : '15px' },
                            React.createElement(Box, { className: 'icon-button-box', padding: '5px', title: "Sorry failed to download this asset" },
                                React.createElement(Icon, { w: '22px', h: '22px', color: AppColor.CloseButton, as: BiError, ml: '1px' })),
                            React.createElement(Text, { fontSize: FontSize.IconTitleFontSize, fontWeight: 'bold' }, 'Error'))))),
            React.createElement(Flex, { mt: '5px' },
                React.createElement(Text, { color: AppColor.InfoColor, fontSize: FontSize.InfoText }, 'Letr ' + ((_b = (_a = rstore.adminTagViewStore.getLetrById(item.letrid)) === null || _a === void 0 ? void 0 : _a.letrMetadata.subject) !== null && _b !== void 0 ? _b : ' Missing.'))));
    }
    render() {
        const rstore = this.context;
        if (!rstore.appheaderStore.showadmindownloadqueue) {
            return React.createElement(React.Fragment, null);
        }
        const items = rstore.appheaderStore.adminQueuedItems;
        return React.createElement(Box, { pos: 'relative', w: '300px', height: testIsMobile() ? window.innerHeight - 300 : window.innerHeight - 200, bg: 'white', zIndex: rstore.appheaderStore.getNextZIndex(), boxShadow: '5px 5px 5px 5px lightgray' },
            React.createElement(Flex, { w: '100%', h: '50px', borderBottomWidth: '1px', align: 'center', borderBottomColor: 'lightgray' },
                React.createElement(Flex, { w: '100%', align: 'center', justify: 'flex-end' },
                    React.createElement(Icon, { color: 'black', w: '25px', h: '25px', as: MdClose, _hover: { cursor: 'pointer' }, onClick: (e) => {
                            e.stopPropagation();
                            rstore.appheaderStore.decrementZIndex();
                            rstore.appheaderStore.setShowAdminDownloadQueueItemView(false);
                        } }))),
            items.length == 0 && React.createElement(Flex, { color: 'rebeccapurple', justify: 'center', h: '100px', w: '100%', align: 'center', flexDir: 'column' },
                React.createElement(Icon, { as: FaFileDownload }),
                React.createElement(Text, { mt: '5px' }, "No items present in the queue")),
            items.length > 0 && React.createElement(Observer, null, () => React.createElement(Virtuoso, { style: { height: window.innerHeight - 400 }, data: items, itemContent: (index, ob) => this.buildItem(ob), endReached: () => {
                } })));
    }
};
AdminDownloadQueueView.contextType = StoreContext;
AdminDownloadQueueView = __decorate([
    observer
], AdminDownloadQueueView);
let DownloadQueueView = class DownloadQueueView extends React.Component {
    buildItem(item) {
        var _a, _b;
        const rstore = this.context;
        return React.createElement(Box, { margin: '10px', borderBottomColor: 'lightgray', borderBottomWidth: '1px', minH: '100px', mt: '5px' },
            React.createElement(Flex, { align: 'center' },
                React.createElement(Flex, { w: '80%', align: 'center' },
                    React.createElement(Icon, { w: '16px', h: '16px', color: AppColor.TopBarIconColor, as: FaFileDownload, ml: '1px' }),
                    React.createElement(Text, { className: 'task-header' }, item.title)),
                React.createElement(Observer, null, () => React.createElement(Flex, { align: 'center' },
                    item.downloading && !item.inqueue &&
                        React.createElement(CircularProgress, { value: item.downloadProgress, color: AppColor.Default },
                            React.createElement(CircularProgressLabel, null, item.downloadProgress + "%")),
                    item.inqueue &&
                        React.createElement(Text, { fontSize: FontSize.SmallIconLabel, fontWeight: 'bold' }, 'Queued'),
                    item.downloaderror &&
                        React.createElement(Flex, { align: 'center', justify: 'center', flexDir: 'column', ml: testIsMobile() ? '5px' : '15px' },
                            React.createElement(Box, { className: 'icon-button-box', padding: '5px', title: "Sorry failed to download this asset" },
                                React.createElement(Icon, { w: '22px', h: '22px', color: AppColor.CloseButton, as: BiError, ml: '1px' })),
                            React.createElement(Text, { fontSize: FontSize.IconTitleFontSize, fontWeight: 'bold' }, 'Error'))))),
            React.createElement(Flex, { mt: '5px' },
                React.createElement(Text, { color: AppColor.InfoColor, fontSize: FontSize.InfoText }, 'Letr ' + ((_b = (_a = rstore.letrAndTagStore.getLetrById(item.letrid)) === null || _a === void 0 ? void 0 : _a.subject) !== null && _b !== void 0 ? _b : ' Missing.'))));
    }
    render() {
        const rstore = this.context;
        if (!rstore.appheaderStore.showdownloadqueue) {
            return React.createElement(React.Fragment, null);
        }
        const items = rstore.appheaderStore.queuedItems;
        return React.createElement(Box, { pos: 'relative', w: '300px', height: testIsMobile() ? window.innerHeight - 300 : window.innerHeight - 200, bg: 'white', zIndex: rstore.appheaderStore.getNextZIndex(), boxShadow: '5px 5px 5px 5px lightgray' },
            React.createElement(Flex, { w: '100%', h: '50px', borderBottomWidth: '1px', align: 'center', borderBottomColor: 'lightgray' },
                React.createElement(Flex, { w: '100%', align: 'center', justify: 'flex-end' },
                    React.createElement(Icon, { color: 'black', w: '25px', h: '25px', as: MdClose, _hover: { cursor: 'pointer' }, onClick: (e) => {
                            e.stopPropagation();
                            rstore.appheaderStore.decrementZIndex();
                            rstore.appheaderStore.setShowDownloadQueueItemView(false);
                        } }))),
            items.length == 0 && React.createElement(Flex, { color: 'rebeccapurple', justify: 'center', h: '100px', w: '100%', align: 'center', flexDir: 'column' },
                React.createElement(Icon, { as: FaFileDownload }),
                React.createElement(Text, { mt: '5px' }, "No items present in the queue")),
            items.length > 0 && React.createElement(Observer, null, () => React.createElement(Virtuoso, { style: { height: window.innerHeight - 400 }, data: items, itemContent: (index, ob) => this.buildItem(ob), endReached: () => {
                } })));
    }
};
DownloadQueueView.contextType = StoreContext;
DownloadQueueView = __decorate([
    observer
], DownloadQueueView);
let TaskIcon = class TaskIcon extends React.Component {
    render() {
        const rstore = this.context;
        const itemid = this.props.item.itemid;
        if (itemid.startsWith("obj-")) {
            return React.createElement(Icon, { w: '20px', h: '20px', title: 'Object', as: FcDocument, ml: '1px' });
        }
        else {
            return React.createElement(Icon, { w: '20px', h: '20px', title: 'Datasheet', as: FcDataSheet, ml: '1px' });
        }
    }
};
TaskIcon.contextType = StoreContext;
TaskIcon = __decorate([
    observer
], TaskIcon);
let NewFilesView = class NewFilesView extends React.Component {
    buildItem(item) {
        var _a, _b;
        const rstore = this.context;
        return React.createElement(Box, { _hover: { cursor: 'pointer' }, onClick: () => {
                if (item.itemurl)
                    window.open(window.location.href.split("#")[0] + "#" + item.itemurl);
            }, margin: '10px', borderBottomColor: 'lightgray', borderBottomWidth: '1px', minH: '100px', mt: '5px' },
            React.createElement(Flex, null,
                React.createElement(Icon, { as: FaFile }),
                React.createElement(Text, { className: 'task-header' }, item.message)),
            React.createElement(Flex, { mt: '5px' },
                React.createElement(Text, null, 'Status ' + (item.status))),
            React.createElement(Flex, { mt: '5px' },
                React.createElement(Text, null, 'Letr ' + ((_b = (_a = rstore.letrAndTagStore.getLetrById(item.letrid)) === null || _a === void 0 ? void 0 : _a.subject) !== null && _b !== void 0 ? _b : ' Missing.'))),
            React.createElement(Flex, { className: 'task-date' },
                React.createElement(Text, null, DateLib.displayDate(item.updatetime))));
    }
    render() {
        const rstore = this.context;
        if (!rstore.homeViewStore.shownewfileview) {
            return React.createElement(React.Fragment, null);
        }
        const files = Array.from(rstore.homeViewStore.newfiles.values()).slice().sort((i1, i2) => i1.updatetime - i2.updatetime).reverse();
        return React.createElement(Box, { pos: 'relative', w: '300px', height: testIsMobile() ? window.innerHeight - 300 : window.innerHeight - 200, bg: 'white', zIndex: rstore.appheaderStore.getNextZIndex(), boxShadow: '5px 5px 5px 5px lightgray' },
            React.createElement(Flex, { w: '100%', h: '50px', borderBottomWidth: '1px', align: 'center', borderBottomColor: 'lightgray' },
                React.createElement(Box, { w: '85%' }, rstore.homeViewStore.gettingfiles && React.createElement(BeatLoader, null)),
                React.createElement(Flex, { w: '15%', align: 'center', justify: 'flex-end' },
                    React.createElement(Icon, { color: 'black', w: '25px', h: '25px', as: MdClose, _hover: { cursor: 'pointer' }, onClick: (e) => {
                            e.stopPropagation();
                            rstore.appheaderStore.decrementZIndex();
                            rstore.homeViewStore.setShowFiles(false);
                        } }))),
            files.length == 0 && React.createElement(Flex, { color: 'rebeccapurple', justify: 'center', h: '100px', w: '100%', align: 'center', flexDir: 'column' },
                React.createElement(Icon, { as: GiPartyPopper }),
                React.createElement(Text, { mt: '5px' }, "No Files")),
            files.length > 0 && React.createElement(Observer, null, () => React.createElement(Virtuoso, { style: { height: window.innerHeight - 400 }, data: files, itemContent: (index, ob) => this.buildItem(ob), atTopStateChange: (ch) => {
                    if (ch) {
                        rstore.homeViewStore.getFiles(true);
                    }
                }, atTopThreshold: 5, endReached: () => {
                    if (rstore.homeViewStore.hasmorefiles) {
                        rstore.homeViewStore.getFiles();
                    }
                } })),
            rstore.homeViewStore.loadingbottomfiles && React.createElement(Flex, { w: '100%', justify: 'center', align: 'center', mt: '10px' },
                React.createElement(BeatLoader, null)));
    }
};
NewFilesView.contextType = StoreContext;
NewFilesView = __decorate([
    observer
], NewFilesView);
let AssignedTasksView = class AssignedTasksView extends React.Component {
    buildItem(item) {
        var _a, _b;
        const rstore = this.context;
        return React.createElement(Box, { _hover: { cursor: item.itemurl !== undefined ? 'pointer' : '' }, onClick: () => {
                if (item.itemurl)
                    window.open(window.location.href.split("#")[0] + "#" + item.itemurl);
            }, margin: '10px', borderBottomColor: 'lightgray', borderBottomWidth: '1px', minH: '100px', mt: '5px' },
            React.createElement(Flex, null,
                React.createElement(TaskIcon, { item: item }),
                React.createElement(Text, { className: 'task-header' }, item.message)),
            React.createElement(Flex, { mt: '5px' },
                React.createElement(Text, null, 'Letr ' + ((_b = (_a = rstore.letrAndTagStore.getLetrById(item.letrid)) === null || _a === void 0 ? void 0 : _a.subject) !== null && _b !== void 0 ? _b : ' Missing.'))),
            React.createElement(Flex, { className: 'task-date' },
                React.createElement(Text, null, DateLib.displayDate(item.updatetime))));
    }
    render() {
        const rstore = this.context;
        if (!rstore.homeViewStore.showtasks) {
            return React.createElement(React.Fragment, null);
        }
        const tasks = Array.from(rstore.homeViewStore.tasks.values()).slice().filter(tk => tk.message !== undefined)
            .sort((i1, i2) => i1.updatetime - i2.updatetime).reverse();
        return React.createElement(Box, { pos: 'relative', w: '300px', height: testIsMobile() ? window.innerHeight - 300 : window.innerHeight - 200, bg: 'white', zIndex: rstore.appheaderStore.getNextZIndex(), boxShadow: '5px 5px 5px 5px lightgray' },
            React.createElement(Flex, { w: '100%', h: '50px', borderBottomWidth: '1px', align: 'center', borderBottomColor: 'lightgray' },
                React.createElement(Box, { w: '85%' }, rstore.homeViewStore.gettingtasks && React.createElement(BeatLoader, null)),
                React.createElement(Flex, { w: '15%', align: 'center', justify: 'flex-end' },
                    React.createElement(Icon, { color: 'black', w: '25px', h: '25px', as: MdClose, _hover: { cursor: 'pointer' }, onClick: (e) => {
                            e.stopPropagation();
                            rstore.appheaderStore.decrementZIndex();
                            rstore.homeViewStore.setShowTaskView(false);
                        } }))),
            tasks.length == 0 && React.createElement(Flex, { color: 'rebeccapurple', justify: 'center', h: '100px', w: '100%', align: 'center', flexDir: 'column' },
                React.createElement(Icon, { as: GiPartyPopper }),
                React.createElement(Text, { mt: '5px' }, "No tasks")),
            tasks.length > 0 && React.createElement(Observer, null, () => React.createElement(Virtuoso, { style: { height: window.innerHeight - 400 }, data: tasks, itemContent: (index, ob) => this.buildItem(ob), atTopStateChange: (ch) => {
                    if (ch) {
                        rstore.homeViewStore.getAssignedTasks(true);
                    }
                }, atTopThreshold: 5, endReached: () => {
                    if (rstore.homeViewStore.hasmoretask) {
                        rstore.homeViewStore.getAssignedTasks();
                    }
                } })),
            rstore.homeViewStore.loadingbottomtasks && React.createElement(Flex, { w: '100%', justify: 'center', align: 'center', mt: '10px' },
                React.createElement(BeatLoader, null)));
    }
};
AssignedTasksView.contextType = StoreContext;
AssignedTasksView = __decorate([
    observer
], AssignedTasksView);
let NotificationView = class NotificationView extends React.Component {
    buildItem(item) {
        var _a, _b, _c;
        const rstore = this.context;
        return React.createElement(Box, { _hover: { cursor: item.accessurl !== undefined ? 'pointer' : '' }, onClick: () => {
                if (item.accessurl)
                    window.open(window.location.href.split("#")[0] + "#" + item.accessurl);
            }, margin: '10px', borderBottomColor: 'lightgray', borderBottomWidth: '1px', minH: '100px', overflow: 'auto', mt: '5px' },
            React.createElement(Text, { color: AppColor.InfoColor, fontSize: FontSize.InfoText, fontWeight: 'bold' }, item.message),
            React.createElement(Flex, { mt: '5px' },
                React.createElement(Text, { color: AppColor.InfoColor, fontSize: FontSize.InfoText }, 'Letr ' + ((_b = (_a = rstore.letrAndTagStore.getLetrById(item.letrid)) === null || _a === void 0 ? void 0 : _a.subject) !== null && _b !== void 0 ? _b : ' Missing.'))),
            React.createElement(Flex, null,
                React.createElement(Text, { color: AppColor.InfoColor, fontSize: FontSize.InfoText }, (_c = item.entryusername) !== null && _c !== void 0 ? _c : '')),
            React.createElement(Flex, { w: '100%', justifyContent: 'flex-end' },
                React.createElement(Text, { color: AppColor.DateColor, fontSize: FontSize.DateFontSize, mr: '5px' }, DateLib.displayDate(item.entrytime))));
    }
    render() {
        const rstore = this.context;
        if (!rstore.homeViewStore.shownotifyview) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(Box, { pos: 'relative', w: '300px', height: testIsMobile() ? window.innerHeight - 300 : window.innerHeight - 200, bg: 'white', zIndex: rstore.appheaderStore.getNextZIndex(), boxShadow: '5px 5px 5px 5px lightgray' },
            React.createElement(Flex, { w: '100%', h: '50px', borderBottomWidth: '1px', align: 'center', borderBottomColor: 'lightgray' },
                React.createElement(Box, { w: '85%' }, rstore.homeViewStore.gettinglogs && React.createElement(BeatLoader, null)),
                React.createElement(Flex, { w: '15%', align: 'center', justify: 'flex-end' },
                    React.createElement(Icon, { color: 'black', w: '25px', h: '25px', as: MdClose, _hover: { cursor: 'pointer' }, onClick: (e) => {
                            e.stopPropagation();
                            rstore.appheaderStore.decrementZIndex();
                            rstore.homeViewStore.setShowNotifyView(false);
                        } }))),
            rstore.homeViewStore.logs.size == 0 && React.createElement(Flex, { color: 'rebeccapurple', justify: 'center', h: '100px', w: '100%', align: 'center', flexDir: 'column' },
                React.createElement(Icon, { as: GiPartyPopper }),
                React.createElement(Text, { mt: '5px' }, "You're caught up on everything")),
            rstore.homeViewStore.logs.size > 0 && React.createElement(Observer, null, () => React.createElement(Virtuoso, { style: { height: window.innerHeight - 400 }, data: Array.from(rstore.homeViewStore.logs.values()).slice().sort((i1, i2) => i1.entrytime - i2.entrytime).reverse(), itemContent: (index, ob) => this.buildItem(ob), atTopStateChange: (ch) => {
                    if (ch) {
                        rstore.homeViewStore.getRecentLogs(true);
                    }
                }, atTopThreshold: 5, endReached: () => {
                    if (rstore.homeViewStore.hasmorelogs) {
                        rstore.homeViewStore.getRecentLogs();
                    }
                } })),
            rstore.homeViewStore.loadingbottomlogs && React.createElement(Flex, { w: '100%', justify: 'center', align: 'center', mt: '10px' },
                React.createElement(BeatLoader, null)));
    }
};
NotificationView.contextType = StoreContext;
NotificationView = __decorate([
    observer
], NotificationView);
